import React, { Component } from 'react';

import Header from './../../Header';
import ReworkItem from './../../Rework/ReworkItem';
import ReworkItems from './../../Rework/ReworkItems';

import Core from './../../../Core/Core';
import ErrorManager from './../../../Core/ErrorManager';
import ErrorBoundary from '../ErrorBoundary';


class Rework extends Component
{
    constructor(props)
    {
        super(props);

        this.conflicts = [];


        this.handleItem = this.handleItem.bind(this);
        this.submit = this.submit.bind(this);

        window.onbeforeunload = function()
        {
            try 
            {
                for(let i = 0; i < this.state.conflicts.length ; i++)
                {
                    if(this.state.conflicts[i].client == null || this.state.conflicts[i].client == "")
                    {
                        return "Certains conflits n'ont pas été résolu. Etes-vous sûr de vouloir quitter ?";
                    }
                }
            }
            catch(e)
            {
                return;
            }
            return;
        }

    }


    componentDidMount()
    {
        document.title = "W-F: Résolution des conflits";
    }


    handleItem(conflicts)
    {
        this.conflicts = conflicts;
        console.log(this.conflicts);
    }




    submit()
    {
        /*for(let i = 0; i < this.state.conflicts.length ; i++)
        {
            if(this.state.conflicts[i].client == null || this.state.conflicts[i].client == "")
            {
                if(window.confirm("Certains conflits n'ont pas été résolu. Ils seront supprimés de la base de donnée, voulez-vous continuer ?") == false)
                    return;
            }
        }*/
        let requests = [];
        if(this.conflicts.length <= 0)
        {
            ErrorManager.Instance.Error("Il n'y a aucun conflit résolu à sauvegarder.");
            return;
        }
        this.conflicts.forEach(e => {
            if(e.client == null || e.client == "")
            {
                /*requests.push(
                    Core.Instance.Request(Core.Address+e.Table_name+"/"+e.Table_id, null, "DELETE")
                );*/
                return;
            }
            requests.push(
                Core.Instance.Request(Core.Address+"Conflict/"+e.id, null, "DELETE")
            );
            requests.push(
                Core.Instance.Request(Core.Address+e.Table_name+"/"+e.Table_id, {
                    "Client_id" : e.client
                }, "PUT")
            );
        });
        Promise.all(requests)
        .then((data) => {
            ErrorManager.Instance.Info("Les conflits ont bien été résolus !");
            window.location.reload();
        });
    }

    render()
    {
        return (
            <ErrorBoundary>
                <Header buttons={[
                    <button className="btn btn-primary" onClick={ this.submit }><li className="fas fa-save"> </li> Enregistrer</button>
                ]} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <ReworkItems onChange={ this.handleItem } />
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

export default Rework;


// WEBPACK FOOTER //
// ./src/Components/Views/Rework/Rework.js